import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AdobeFlashSvg = function AdobeFlashSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#501002",
      d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FF7373",
      d: "M9.086 16.167v-3.623h3.593V11.36H9.086V8.934h4.072l.006-1.202H7.645v8.435zm7.134.087c.193 0 .426-.046.636-.116v-.893l-.303-.011c-.479-.041-.683-.333-.683-.858V7.499h-1.388v7.04c0 .858.175 1.715 1.738 1.715"
    })]
  });
};
export var AdobeFlash = function AdobeFlash(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: AdobeFlashSvg
  }));
};